// extracted by mini-css-extract-plugin
module.exports = {"pr":"GiftingAppeal_pr__3iyr-","pr_userIcon":"GiftingAppeal_pr_userIcon__1ovcl","pr_body":"GiftingAppeal_pr_body__apLY9","pr_body_p":"GiftingAppeal_pr_body_p__3iWWJ"};